import styles from 'css/src/components/public-pages/AboutPage.module.scss';

import React from 'react';

import JumboCta from 'js/src/components/common/JumboCta';
import IconCircle from 'js/src/components/common/ui/IconCircle';

const AboutPage = React.memo(function AboutPage() {
    return (
        <div className={`${styles['about-page-container']} overflow-x-hidden mt-l5-0`}>
            <div className={`p-l5-48 mb-l5-48 ${styles['section-1']} rounded-0`}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-sm-12">
                            <div className="d-flex flex-column align-items-start mb-l5-48 ms-l5-md-48 ps-l5-md-48">
                                <h6>ABOUT</h6>
                                <h3>What is Lumen5?</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6 col-sm-12">
                            <div className="d-flex flex-column align-items-start mb-l5-48 ms-l5-md-48 ps-l5-md-48">
                                <h5 className="px-l5-0 w-100">
                                    Lumen5 is a video creation platform designed for brands and
                                    businesses to produce engaging video content for social posts,
                                    stories, and ads.
                                    <br />
                                    <br />
                                    Our goal is to enable anyone without training or experience to
                                    easily create amazing videos in minutes.
                                    <br />
                                    <br />
                                    Our technology enables marketing teams to focus on the story and
                                    narrative while relying on our system to do the heavy lifting.
                                </h5>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <div className="d-flex flex-column align-items-start mb-l5-48 ms-l5-md-48 ps-l5-md-48">
                                <h5 className="px-l5-0 w-100">
                                    Not only does our platform offer tools to make videos, Lumen5
                                    takes it a step further to supply all the resources needed to
                                    make thumb-stopping videos.
                                    <br />
                                    <br />
                                    Our built-in media library offers access to millions of stock
                                    footage, photos, and music tracks.
                                    <br />
                                    <br />
                                    This means that our users have access to everything they need
                                    without having to record or purchase any digital assets
                                    externally.
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-l5-48 mb-l5-48 section-photos my-l5-md-8">
                <div className="container">
                    <img
                        loading="lazy"
                        className="w-100 banner-img"
                        src="https://cdn.lumen5.com/lumen5-site-images/team-pic1.png"
                    />
                </div>
            </div>

            <div className={`p-l5-48 mb-l5-48 ${styles['section-2']} my-l5-md-8`}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {/* section 3.1 */}
                        <div className="col-md-6 col-sm-12 order-md-2 order-sm-1">
                            <div className="d-flex justify-content-center">
                                <div className="d-flex flex-column align-items-start my-l5-48 ps-l5-md-48">
                                    <h5 className="mt-l5-8">
                                        <IconCircle
                                            materialIconName="construction"
                                            color="text-white"
                                            backgroundColor="primary"
                                        />
                                    </h5>

                                    <div className="d-flex flex-column my-l5-16">
                                        <h3>The challenge</h3>
                                    </div>

                                    <h5 className="my-l5-16 px-l5-0">
                                        Video content has been rapidly transforming the marketing
                                        landscape and video content has quickly claimed the
                                        spotlight as the single most popular form of storytelling.
                                        However, tools for producing video content have not evolved
                                        quickly enough to meet this new demand. Many experts are
                                        required to produce a video such as scriptwriters,
                                        photographers, cinematographers, audio engineers, video
                                        editors, and more. The video production process is
                                        complicated, time-consuming, and extremely expensive.
                                    </h5>
                                </div>
                            </div>
                        </div>
                        {/* section 3.2 */}
                        <div className="col-md-6 col-sm-12 order-md-1 order-sm-2">
                            <div className="d-flex container justify-content-sm-start justify-content-md-center align-items-center mt-l5-48 pt-l5-48">
                                <img
                                    loading="lazy"
                                    className="w-100 banner-img"
                                    src="https://cdn.lumen5.com/lumen5-site-images/about-problem1.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`p-l5-48 mb-l5-48 ${styles['section-3']} rounded-0`}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {/* section 4.1 */}
                        <div className="col-md-6 col-sm-6 col-sm-12">
                            <div className="d-flex justify-content-center">
                                <div className="d-flex flex-column align-items-start my-l5-48 ps-l5-md-48">
                                    <h5 className="mt-l5-8">
                                        <IconCircle
                                            materialIconName="lightbulb"
                                            color="text-white"
                                            backgroundColor="primary"
                                        />
                                    </h5>

                                    <div className="d-flex flex-column my-l5-16">
                                        <h3>Our solution</h3>
                                    </div>

                                    <h5 className="my-l5-16 px-l5-0">
                                        Video editing is a time-consuming process because it
                                        requires a lot of small tweaks and fine tuning. Using
                                        Machine Learning, we automate these tasks to help our users
                                        create quality videos with minimal time, effort, and
                                        training. For example, the duration of each scene is
                                        algorithmically determined based on the number of words in
                                        the scene, text positioning is intelligently placed to avoid
                                        covering important subjects such as human faces, important
                                        keywords are automatically emphasized and highlighted with
                                        your brand color, and a credit scene is generated at the end
                                        of each video to help you stay compliant with copyright
                                        laws.
                                    </h5>
                                </div>
                            </div>
                        </div>
                        {/* section 4.2 */}
                        <div className="col-md-6 col-sm-12">
                            <div className="d-flex justify-content-sm-start justify-content-md-center align-items-center mt-l5-48 pt-l5-48">
                                <img
                                    loading="lazy"
                                    className="w-100 banner-img"
                                    src="https://cdn.lumen5.com/lumen5-site-images/about-solution1.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-l5-48">
                <JumboCta
                    header="Join over 5,000,000 companies using Lumen5 to tell their stories."
                    body="Lumen5 is a video creation software that helps marketers, publishers, and brands create video content in a breeze, without any technical expertise."
                />
            </div>
        </div>
    );
});

export default AboutPage;
